
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5.303 5.303"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.17 0a.143.143 0 00-.127.064A.261.261 0 002 .212v1.8H.212a.261.261 0 00-.148.041A.143.143 0 000 2.18v.953c0 .056.021.099.064.127a.261.261 0 00.148.042H2v1.789c0 .056.015.106.043.148.028.042.07.064.127.064h.952a.143.143 0 00.127-.064.261.261 0 00.043-.148V3.302H5.09a.261.261 0 00.148-.042.143.143 0 00.064-.127V2.18a.143.143 0 00-.064-.127.261.261 0 00-.148-.042h-1.8v-1.8A.261.261 0 003.25.065.143.143 0 003.122 0z"}})])
          )
        }
      }
    